<template>
  <div>
    <b-card>
      <div style="position: relative">
        <LoadingOverlay :loading="jobsLoading" />

        <div class="d-flex justify-content-between">
          <h3 v-if="$route.name == 'job-vacancies-management'">فرص العمل</h3>
          <h3 v-else>فرص التطوع</h3>
          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            :key="$route.meta.slug"
            variant="success"
            @click="
              $router.push({
                name: `${
                  $route.name == 'job-vacancies-management'
                    ? 'add-jobs'
                    : 'add-volunteer'
                }`,
              })
            "
          >
            <feather-icon icon="PlusIcon" /> إضافة</b-button
          >
        </div>
        <hr />

        <div>
          <b-table
            :items="jobs"
            :fields="fields"
            striped
            responsive
            :show-empty="true"
            empty-text="لا يوجد سجلات لعرضها"
            v-can="{ slug: $route.meta.slug, action: 'S' }"
            :key="`${$route.meta.slug}table`"
          >
            <template #cell(action)="data">
              <b-row>
                <div
                  v-can="{ slug: $route.meta.slug, action: 'U' }"
                  class="mx-1"
                  @click="
                    $router.push({
                      name: `${
                        $route.name == 'job-vacancies-management'
                          ? 'edit-jobs'
                          : 'edit-volunteer'
                      }`,
                      params: { id: data.item.id },
                    })
                  "
                >
                  <feather-icon
                    icon="EditIcon"
                    color="#048042"
                    style="cursor: pointer"
                  />
                </div>
                <div
                  v-can="{ slug: $route.meta.slug, action: 'D' }"
                  class="mx-1"
                  @click="
                    activDelete = true;
                    deleteId = data.item.id;
                  "
                >
                  <feather-icon
                    icon="Trash2Icon"
                    color="#ea5455"
                    style="cursor: pointer"
                  />
                </div>
              </b-row>
            </template>
          </b-table>

          <Pagination
            v-can="{ slug: $route.meta.slug, action: 'S' }"
            class="mt-2"
            v-model="currentPage"
            :total-rows="pagination.total_row"
            :per-page="pagination.per_page"
            align="end"
          >
          </Pagination>
        </div>
      </div>
    </b-card>
    <b-modal
      v-model="activDelete"
      cancel-variant="outline-secondary"
      centered
      title="تأكيد حذف  "
      size="md"
      footer-class="removed"
      class="edit-modal"
      id="modal"
      no-close-on-backdrop
    >
      هل أنت متأكد من الحذف
      <b-row class="px-1 justify-content-end">
        <b-button @click="activDelete = false" class="mx-1">إلغاء</b-button>
        <b-button
          variant="danger"
          @click="
            () => {
              deleteSlider();
              activDelete = false;
            }
          "
        >
          حذف
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BTable,
  BFormCheckbox,
  BRow,
  BCol,
  BAvatar,
  BBadge,
  BModal,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import Pagination from "@/components/pagination/index.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  components: {
    BCard,
    BButton,
    BTable,
    BFormCheckbox,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    BModal,
    Pagination,
    LoadingOverlay,
  },
  props: {
    type: String,
  },
  data() {
    return {
      currentPage: 1,
      deleteId: "",
      activDelete: false,
      fields: [
        { key: "name", label: "اسم الشاغر" },
        { key: "number", label: "رقم الشاغر" },
        { key: "positionType", label: "مجال العمل" },
        { key: "start_date", label: "تاريخ الإعلان" },
        { key: "end_date", label: "تاريخ إغلاق " },
        { key: "action", label: "" },
      ],
      routerCh: this.$route.name,
    };
  },
  methods: {
    deleteSlider() {
      this.$store.dispatch(`manageInterfaceNgo/jobsManage/deletJob`, {
        page: this.currentPage,
        id: this.deleteId,
        type:
          this.$route.name == "job-vacancies-management" ? "job" : "volunteer",
      });
    },
    submitGetJob() {
      this.$store.dispatch(`manageInterfaceNgo/jobsManage/getJobs`, {
        page: this.currentPage,
        type:
          this.$route.name == "job-vacancies-management" ? "job" : "volunteer",
      });
    },
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/jobsManage", [
      "jobsLoading",
      "jobs",
      "pagination",
    ]),
  },
  watch: {
    "$route.name"() {
      this.submitGetJob();
      this.currentPage = 1;
    },
    currentPage(val) {
      this.$store.dispatch(`manageInterfaceNgo/jobsManage/getJobs`, {
        type:
          this.$route.name == "job-vacancies-management" ? "job" : "volunteer",
        page: val,
      });
    },
  },
  created() {
    this.$store.dispatch(`manageInterfaceNgo/jobsManage/getJobs`, {
      type:
        this.$route.name == "job-vacancies-management" ? "job" : "volunteer",
    });
  },
};
</script>
